import {isFilled} from '@prismicio/client'
import {SliceZone} from '@prismicio/react'
import type {BlogPostDocument, ButtonDocument, NavigationDocumentData} from 'prismicio-types'
import {memo} from 'react'
import {components} from 'slices'
import {getButtonsData} from 'src/common/helpers'
import {Layout} from 'src/common/Layout'
import {Meta} from 'src/common/Meta'
import {PageFaqSEO} from 'src/common/PageFaqSEO'
import type {ParentUid} from 'src/common/utils/documentHelpers'
import {getAlternateLanguagesWithParent, getBreadcrumbs, getMetaProps} from 'src/common/utils/documentHelpers'

export const BlogPost = memo(function (props: {
  navigationData: NavigationDocumentData
  page: BlogPostDocument
  parentUids?: Array<ParentUid>
  buttonsData?: Array<ButtonDocument>
  categories?: Array<{category_name: string; value: string}>
  blogPosts?: Array<BlogPostDocument<string>>
  totalPages?: number
}) {
  const data = props.page.data

  const {primaryButtonData: primaryNavButton, secondaryButtonData: secondaryNavButton} = getButtonsData({
    buttonsData: props.buttonsData,
    primaryButton: data.primary_nav_button,
    secondaryButton: data.secondary_nav_button,
  })

  return (
    <Layout
      alternateLanguages={getAlternateLanguagesWithParent(props.page.alternate_languages, props.parentUids)}
      breadcrumbs={getBreadcrumbs(props.page)}
      navigationData={props.navigationData}
      pageUid={props.page.uid}
      locale={props.page.lang}
      parentUids={props.parentUids}
      primaryNavButton={primaryNavButton}
      secondaryNavButton={secondaryNavButton}
      hidePrimaryNavButton={!!data.hide_primary_nav_button}
      hideSecondaryNavButton={!!data.hide_secondary_nav_button}
      primaryNavButtonScrollText={data.primary_nav_button_scroll_into_view_text}
      primaryNavButtonScrollId={data.primary_nav_button_scroll_into_view_id}
      secondaryNavButtonScrollText={data.secondary_nav_button_scroll_into_view_text}
      secondaryNavButtonScrollId={data.secondary_nav_button_scroll_into_view_id}
    >
      <Meta {...getMetaProps(props.page)} />
      <PageFaqSEO slices={data.slices} />

      <SliceZone
        components={components}
        context={{
          pageUid: props.page.uid,
          category: props.page.data.category,
          description: props.page.data.description,
          publishedDate: props.page.data.date,
          parentPage: isFilled.contentRelationship(props.page.data.breadcrumbs)
            ? props.page.data.breadcrumbs
            : props.page.data.parent_page,
          blogPosts: props.blogPosts,
          categories: props.categories,
          totalPages: props.totalPages,
          buttonsData: props.buttonsData,
        }}
        slices={props.page.data.slices}
      />
    </Layout>
  )
})
